import { ErrorResolution } from '../../app/common/errorResolution/errorResolution';
import { ILinkedService } from './IdentityVerificationInterface';

export enum IdentityVerificationActionType {
    CLOSE_IDENTITY_VERIFICATION_OVERLAY = 'CLOSE_IDENTITY_VERIFICATION_OVERLAY',
    OPEN_IDENTITY_VERIFICATION_OVERLAY = 'OPEN_IDENTITY_VERIFICATION_OVERLAY',
}

export type IdentityVerificationAction =
    | { type: IdentityVerificationActionType.CLOSE_IDENTITY_VERIFICATION_OVERLAY; payload: {} }
    | { type: IdentityVerificationActionType.OPEN_IDENTITY_VERIFICATION_OVERLAY; payload: {} };

export enum EKYCActionType {
    GET_LINKED_SERVICES_REQUEST = 'GET_LINKED_SERVICES_REQUEST',
    GET_LINKED_SERVICES_SUCCESS = 'GET_LINKED_SERVICES_SUCCESS',
    GET_LINKED_SERVICES_FAILURE = 'GET_LINKED_SERVICES_FAILURE',

    LOAD_LINKED_SERVICES_CONFIG_REQUEST = 'LOAD_LINKED_SERVICES_CONFIG_REQUEST',
    LOAD_LINKED_SERVICES_CONFIG_SUCCESS = 'LOAD_LINKED_SERVICES_CONFIG_SUCCESS',
    LOAD_LINKED_SERVICES_CONFIG_FAILURE = 'LOAD_LINKED_SERVICES_CONFIG_FAILURE',
}

export interface ILinkedServicesRequestAction {
    type: EKYCActionType.GET_LINKED_SERVICES_REQUEST;
    payload: {};
}

export interface ILinkedServicesFailureAction {
    type: EKYCActionType.GET_LINKED_SERVICES_FAILURE;
    payload: { errorResolution: ErrorResolution };
}

export interface ILinkedServicesSuccsessAction {
    type: EKYCActionType.GET_LINKED_SERVICES_SUCCESS;
    payload: ILinkedService[];
}

export type EKYCAction =
    | ILinkedServicesSuccsessAction
    | ILinkedServicesFailureAction
    | ILinkedServicesRequestAction;
